import { DateTime } from "luxon";

export const PIN_LENGTH = 4;

export const formatTime = (unixSeconds: number): string =>
  DateTime.fromSeconds(unixSeconds).toLocaleString(DateTime.TIME_SIMPLE);

export const formatMeetingDate = (isoDate: string): string => {
  // Parsed in the local zone, not UTC, so a date-only string keeps its calendar day.
  const date = DateTime.fromISO(isoDate);
  return date.isValid ? date.toLocaleString(DateTime.DATE_MED) : isoDate;
};

export const initials = (name: string): string =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]!.toUpperCase())
    .join("");
